
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_11017_23163)"}},[_c('path',{attrs:{"d":"M16.25 20a.834.834 0 01-.774-.523l-.704-1.761-1.763-.743a.839.839 0 01.03-1.548l1.74-.659.697-1.743a.84.84 0 011.548 0l.7 1.75 1.75.7a.839.839 0 010 1.55l-1.75.7-.7 1.75a.833.833 0 01-.774.527z","fill":"#12ACF2"}}),_c('path',{attrs:{"d":"M8.333 17.5a1.667 1.667 0 01-1.613-1.177l-1.345-4.206-4.22-1.412A1.693 1.693 0 011.2 7.479L5.385 6.2l1.41-4.211A1.63 1.63 0 018.424.833c.74 0 1.39.49 1.598 1.199l1.276 4.18 4.192 1.341a1.702 1.702 0 010 3.227l-4.2 1.343-1.343 4.2A1.666 1.666 0 018.334 17.5z","fill":"#2C8DFF"}}),_c('path',{attrs:{"d":"M17.083 5.833a.833.833 0 01-.808-.63l-.297-1.192-1.195-.321a.834.834 0 01.029-1.617l1.166-.27.297-1.172a.834.834 0 011.617 0l.294 1.182 1.182.295a.833.833 0 010 1.617l-1.181.296-.296 1.181a.833.833 0 01-.808.631z","fill":"#176CD8"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_11017_23163"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    